import {useInfiniteQuery} from '@tanstack/react-query';
import {UseProcedureQueryProps} from './types';
import {QUERY_KEYS} from 'infra/libs/react-query/queryKeys';
import {searchProcedure} from 'presentation/modules/guide/shared/services/searchProcedure';

function useSearchProcedureQuery({debouncedSearch, minChars}: UseProcedureQueryProps) {
	const {data, fetchNextPage, refetch, hasNextPage, isFetchingNextPage, isLoading, isError} =
		useInfiniteQuery({
			queryKey: [QUERY_KEYS.SEARCH_PROCEDURE_GUIDE, debouncedSearch],
			queryFn: async ({pageParam = 1, signal}) => {
				return await searchProcedure({
					termo: debouncedSearch,
					page: pageParam,
					pageSize: 20,
					signal,
				});
			},
			initialPageParam: 1,
			getNextPageParam: (lastPage, allPages) => {
				if (!lastPage) return undefined;
				const loadedCount = allPages.length * lastPage.pageSize;
				return loadedCount < lastPage.totalRecords ? allPages.length + 1 : undefined;
			},
			enabled: debouncedSearch.length >= minChars,
		});
	return {
		data,
		fetchNextPage,
		hasNextPage,
		isFetchingNextPage,
		isLoading,
		isError,
		refetch,
	};
}

export {useSearchProcedureQuery};
